import * as actionType from './actionType';
import { ApiGateWay } from '../../../ApiGateWay/ApiGateWay';
import { Config } from '../../../config/config';
import { AuthService } from '../../../services/AuthService';
import Cookie from 'js-cookie';
import LZString from 'lz-string';

const config = JSON.parse(Config);
const apiInterface = config['api1'];

export const addStoreView = () => ({
  type: actionType.ADD_VIEW_MODE,
  payload: 'Add'
});
export const addStore = (data) => ({
  type: actionType.ADD_STORE,
  payload: data
});


export const updateStoreView = () => ({
  type: actionType.UPDATE_VIEW_MODE,
  payload: 'Update'
});
export const getStores_sucess = (data) => ({
  type: actionType.GET_STORE_LIST,
  payload: data,
})
export const FilterdStore = (data) => ({
  type: actionType.GET_SELECTED_STORE,
  payload: data,
})
export const StoreStart = () => ({
  type: actionType.GET_STORE_LIST_START,
  payload: true,
})
export const StoreStop = () => ({
  type: actionType.GET_STORE_LIST_STOP,
  payload: false,
})

export const StoreError = (Error) => ({
  type: actionType.GET_STORE_LIST_ERROR,
  payload: Error,
})

export const update_store_success = (payload) => ({
  type: actionType.UPDATE_STORE_DATA,
  payload
})

export const load_store_success = (payload) => ({
  type: actionType.LOAD_STORE_DATA,
  payload
})

export const api_success = (payload) => ({
  type: actionType.API_SUCCESS,
  payload
})
export const isEditStore = (payload) => ({
  type: actionType.IS_STORE_EDIT,
  payload
})
export const isStoreCreate = (payload) => ({
  type: actionType.IS_STORE_CREATE,
  payload
})
export const isStoreList = (payload) => ({
  type: actionType.IS_STORE_LIST,
  payload
})
export const isStoreView = (payload) => ({
  type: actionType.IS_STORE_VIEW,
  payload
})
export const isLogin = (payload) => ({
  type: actionType.IS_LOGIN,
  payload,
});

export const getStoreList = (userId,type) => async (dispatch) => {

  dispatch(StoreStart());
  const data = {
    'store_type_id': type,
    'fedid': userId
  }
  
  ApiGateWay.PostCall1(`${apiInterface}/StoreInfo/loadstoresinitialdata`, data)
    .then((response) => {
      if (response) {
        let Stores = [];
        response[11].Table12.forEach((element, index) => {
          // console.log(element)
          Stores.push({
            key: index + 1,
            storeId:element.store_id,
            CostCenter: element.store_costcenter,
            BuildingType_name: element.building_type_name,
            StoreName:element.store_name,
            GstNumber:element.gst_number,
            StoreManagerEmail:element.store_manager_email,
            ZOMCoachEmail:element.zone_operation_maintenance_coach_email,
            CMEmail:element.construction_manager_email, 
            ProductLeaderEmail:element.product_leader_email,
            SOREmail:element.store_operation_referent_email,

            Property_type_name:element.property_type,

            StoreType:element.store_type,
            StoreCityId:Number(element.store_city_id),
            StoreAddress:element.store_address,
            Zone: element.store_zone_id,
            ZoneName: element.zone_name,
            City: element.city_name,
            StateId:Number(element.store_state_id),
            StateName:element.state_name,
            TotalBuitlArea:element.prop_builtup_area,
            TotalSalesArea:element.prop_sales_area,
            BuildingType:Number(element.building_type),
            CarParking:element.prop_car_parking,
            NumberOfCarParking:element.prop_number_of_cars_parking,
            NumberOfTwoWheelerParking:element.prop_number_of_two_wheelars_parking,
            NumberOfStackParking:element.prop_number_of_stack_parking,
            PlayGroundConcrete:element.prop_playground_concreate,
            PlayGroungSize:element.prop_playground_concreate_size,
            PlayGroundTurf:element.prop_playground_turf,
            PlayGroundTurfSize:element.prop_playground_turf_size,
            StoreOpeningDate:element.landlard_store_opening_date,
            LeaseStartDate:element.landlard_lease_start_date,
            LeaseEndDate:element.landlard_lease_end_date,
            WarrantyDate:element.prop_landlard_warranty_end_date,
            LandLordName:element.landlard_name,
            LandLordEmail:element.landlard_email,
            LandLordContactNumber:element.landlard_contact_number,
            LandLordAltNumber:element.landlard_alter_contact_number,
            

            StoreOpReferentNumber:element.store_operation_referent_mobile_number,
            StoreOpRefName:element.store_operation_referent_name,
            StoreOpRefId:element.store_operation_referent_employee_id,

            StoreMgrName:element.store_manager_name,
            StoreMgrNumber:element.store_sm_mobile_number,
            StoreMgrId:element.store_sm_employee_id,


            ZoneOpMCoachName:element.zone_operation_maintenance_coach_name,
            ZoneOpCoachNumber:element.store_zomc_mobile_number,
            ZoneOpCoachId:element.store_zomc_employee_id,

            constructionMgrName:element.construction_manager_name,
            counsturtionMgrMobNumber:element.store_cm_mobile_number,
            ConstructionMgrId:element.store_cm_employee_id,

            MaintainceLeaderName:element.product_leader_name,
            MaintainceLeaderNumber:element.store_maintaince_lead_mobile_number,
            MaintainceLeaderId:element.store_maintaince_lead_employee_id,
            MaintainenceChecklistOne: element.maintainence_checklist_one,

            Status:element.store_active_flag ==1?'Active':'In Active'
          })
        });

        const storeTypes = response[1]?.Table2?.map(item => {
          return {
            'id': item.code_id,
            'value': item.code_value
          }
        });

        const States = response[2]?.Table3?.map(item => {
          return {
            'id': item.code_id,
            'value': item.code_value
          }
        });

        const Zones = response[3]?.Table4?.map(item => {
          return {
            'id': item.code_id,
            'value': item.code_value
          }
        });

        const cities = response[4]?.Table5?.map(item => {
          return {
            'id': item.code_id,
            'value': item.code_value
          }
        });

        const propertyTypes = response[5]?.Table6?.map(item => {
          return {
            'id': item.name,
            'value': item.value
          }
        });
        const buildingTypes = response[12]?.Table13?.map(item => {
          return {
            'id': item.building_type_id,
            'value': item.building_type_name
          }
        });

        const ConstructionManagerList = response[6]?.Table7 
        const StoreOperationalList = response[7]?.Table8;
        // const StoreManagerList = response[8]?.Table9;
        if(response[8]?.Table9.length!=0){
          var StoreManagerList = response[8]?.Table9;
        }else{
          var StoreManagerList = response[7]?.Table8;
        }
        const ZonalManagerList = response[9]?.Table10;
        const  MaintenanceLeaderList=response[10]?.Table11
        const AllowStores= response[13]?.Table14
        Stores.reverse();
        const StoreData = { Stores, storeTypes, States, Zones, cities, propertyTypes, StoreOperationalList, StoreManagerList, ZonalManagerList,buildingTypes,ConstructionManagerList,MaintenanceLeaderList, AllowStores }
        dispatch(getStores_sucess(StoreData))
        
      }
    })
    .catch((e) => {
      dispatch(StoreError('Something went wrong please try again after sometime'))
    })

}
export const doUpdateStorePic = (values) => async (dispatch) => {
  dispatch(StoreStart());
  ApiGateWay.SaveData(apiInterface + '/StoreInfo/uploadimages', values)
      .then((result) => {
        dispatch(StoreStop())
      })
      .catch(() => {
        dispatch(StoreStop()) 
      })
}

export const updateStoreInfo = (data) => async (dispatch) => {
  
  dispatch(StoreStart());
  
  ApiGateWay.SaveData(`${apiInterface}/StoreInfo/updatestoreinfo`, data)
    .then(response => {
      dispatch(api_success(response[1]?.Table2[0].status_code))
      if(response[0]?.Table1[0].status_code=='000'){
        dispatch(StoreError(response[1]?.Table2[0].status_msg))
      }else{
        dispatch(StoreError(response[0]?.Table1[0].status_msg)) 
      }
    
    }).
    catch(error => {
      dispatch(StoreError('Something went wrong please try again after sometime'))
    })
}
export const addStoreInfo = (data) => async (dispatch) => {
  dispatch(StoreStart()); 
  ApiGateWay.SaveData(`${apiInterface}/StoreInfo/updatestoreinfo`, data)
    .then(response => {
      dispatch(api_success(response[1]?.Table2[0].status_code))
      if(response[1]?.Table2[0].status_code=='000'){
        dispatch(StoreError(response[1]?.Table2[0].status_msg))
      }else{
        dispatch(StoreError(response[1]?.Table2[0].status_msg)) 
      }
    
    }).
    catch(error => {
      dispatch(StoreError('Something went wrong please try again after sometime'))
    })
}


export const storeViewDetails = (storeId) => (dispatch) => {
  const data = {
    'store_id': storeId,
  }
  dispatch(StoreStart());
  ApiGateWay.PostCall1(`${apiInterface}/StoreInfo/loadonestoreinfo`, data)
    .then(response => {
      const lotA = response[1]?.Table2;
      const lotB = response[2]?.Table3;
      const storeInfo={lotA,lotB}
      // console.log(storeInfo,'storeInfo');
      dispatch(load_store_success(storeInfo))
    }).catch(err => {
      dispatch(StoreError('Something went wrong please try again after sometime'))
    })
}


export const getSelectedStoreList = (data) => (dispatch) => {
   dispatch(FilterdStore(data))
}
export const isEdit=(data)=>(dispatch)=>{
  dispatch(isEditStore(data))
}
export const CretateStore=(data)=>(dispatch)=>{
  dispatch(isStoreCreate(data))
}
export const StoreList=(data)=>(dispatch)=>{
  dispatch(isStoreList(data))
}
export const ShowStoreDetail=(data)=>(dispatch)=>{
  dispatch(isStoreView(data))
}
export const isLoginOrNot=(data)=>(dispatch)=>{
  dispatch(isLogin(data))
}

export const setLogOut = (info) => async (dispatch) => {
  const jsonData = Cookie.get('currentUser');
            let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
  const user = JSON.parse(decompressedData);
  
        const data = {
        "fedid":user['userId'],
        "app_type": "Web"
      }
      ApiGateWay.PostCall1(
        apiInterface +
        '/StoreInfo/logout', data).then(
          (response)=>{
            if(response[0]["Table1"][0].status_code =="00"){
              dispatch(isLoginOrNot(false))
              localStorage.setItem("isLogin",false)
              if(info==="timeout"){
                alert('Your session has expired. Please login again.');
              }
              localStorage.removeItem('Login');
              document.cookie.split(';').forEach(function (c) {
                document.cookie = c
                  .replace(/^ +/, '')
                  .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
              });
              (function () {
                document.cookie.split(';').forEach(function (c) {
                  document.cookie = c
                    .replace(/^ +/, '')
                    .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
                });
              })();
              document.cookie =
                'my_cookie=; path=/; domain=idpdecathlon.oxylane.com; expires=' +
                new Date(0).toUTCString();

              window.localStorage.clear();
              Cookie.remove('PF');
              Cookie.remove('currentUser');
              Cookie.remove('stores');
              Cookie.remove('storesAll');
              Cookie.remove('warehouses');

              localStorage.clear();
              sessionStorage.clear();
              AuthService.logout();
              var cookies = document.cookie.split(';');

              for (var i = 0; i < cookies.length; i++) {
                var cookie = cookies[i];
                var eqPos = cookie.indexOf('=');
                var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
              }
              (function () {
                var cookies = document.cookie.split('; ');
                console.log(cookies);
                for (var c = 0; c < cookies.length; c++) {
                  var d = window.location.hostname.split('.');
                  while (d.length > 0) {
                    var cookieBase =
                      encodeURIComponent(cookies[c].split(';')[0].split('=')[0]) +
                      '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' +
                      d.join('.') +
                      ' ;path=';

                    var p = window.location.pathname.split('/');
                    document.cookie = cookieBase + '/';
                    while (p.length > 0) {
                      document.cookie = cookieBase + p.join('/');
                      p.pop();
                    }
                    d.shift();
                  }
                }
              })();
            return (window.location = '/');
            }
          }
        )
      .catch((e) => {
        localStorage.setItem("isLogin",true);
      })
} 